// AuthKit.js
import React, {
    createContext,
    useContext,
    useEffect,
    useState,
  } from "react";
  import { useUnifiedAuth } from "./useUnifiedAuth";   // ← tu hook sin tocar
  import { app as teamsApp } from "@microsoft/teams-js";
  
  /* ---------- Contexto ---------- */
  const AuthContext = createContext(null);
  
  export function AuthProvider({ children }) {
    const auth = useUnifiedAuth();            // estado de sesión
    const [teamsInfo, setTeamsInfo] = useState({
      insideTeams: false,
      hostClientType: "browser",
    });
  
    /* Detectar Teams UNA sola vez */
    useEffect(() => {
      (async () => {
        try {
          await teamsApp.initialize();
        //   const h = await teamsApp.getHostInfo();
        //   setTeamsInfo({ insideTeams: true, hostClientType: h.hostClientType });
        const context = await teamsApp.getContext();
      setTeamsInfo({
        insideTeams: true,
        hostClientType: context.app.host.clientType
      });
        } catch {
          setTeamsInfo({ insideTeams: false, hostClientType: "browser" });
        }
      })();
    }, []);
  
    return (
      <AuthContext.Provider value={{ ...auth, teamsInfo }}>
        {children}
      </AuthContext.Provider>
    );
  }
  
  /* Hook de conveniencia */
  export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth debe usarse dentro de <AuthProvider>");
    return ctx;
  };
  
  /* ---------- Templates ---------- */
  export function AuthenticatedTemplate({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    return user ? <>{children}</> : null;
  }
  
  export function UnauthenticatedTemplate({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    return !user ? <>{children}</> : null;
  }
  
  /* ---------- Botones ---------- */
  export function SignInButton({ children = "Sign in" }) {
    const { login } = useAuth();
    return <button onClick={login}>{children}</button>;
  }
  
  export function SignOutButton({ children = "Sign out" }) {
    const { logout } = useAuth();
    return <button onClick={logout}>{children}</button>;
  }
  
  /* ---------- Estado / mensajes ---------- */
  export function AuthStatus() {
    const { user, loading, error, teamsInfo } = useAuth();
  
    return (
      <div style={{ whiteSpace: "pre-wrap" }}>
        {/* Info de Teams */}
        <p style={{ fontSize: 13 }}>
          inside Teams: <b>{String(teamsInfo.insideTeams)}</b> — host:{" "}
          <b>{teamsInfo.hostClientType}</b>
        </p>
  
        {/* Estado de auth */}
        {loading && <p>Cargando autenticación…</p>}
        {error && <p style={{ color: "red" }}>⚠ {error.message}</p>}
        {!loading && !error && user && (
            <>
                <p>✔ Signed in as <strong>{user.username}</strong></p>
                {user.name !== user.username && <p>Name: {user.name}</p>} 
            </>
        )}
        {!loading && !error && !user && <p>No user is logged in</p>}
      </div>
    );
  }
  